module.exports = __webpack_public_path__ + "img/button-a-patient-02-carson.a1f50d6c.png";